module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/mrgarita-82430083.aac";